/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';
import { campingSearchAxios } from '../utils/externalAxios';
import * as utils from '../utils/utils';

export const fetchAmenities = (campgroundID) => (dispatch) => {
    const args = {
        fq: [`parent_asset_id:${campgroundID}`],
        size: 500,
    };

    const url = utils.urlWithParams(`${process.env.API}/search/amenities`, args);

    return campingSearchAxios
        .get(url)
        .then(utils.status)
        .then((json) => json.data)
        .then((json) => {
            const payload = json;
            if (payload.size === 0) payload.results = [];
            dispatch(utils.requestSuccess(types.GET_AMENITIES, payload.results));

            return Promise.resolve(payload);
        })
        .catch((error) => {
            if (error.response && error.response.data) {
                dispatch(
                    utils.requestFailure(
                        types.GET_AMENITIES_ERROR,
                        'Error amenity results.'
                    )
                );
            }
            return Promise.resolve(error);
        });
};
